<script>
import FieldWrapper from "./FieldWrapper";
import { mapState } from "vuex";
export default {
  components: {
    FieldWrapper
  },
  computed: {
    ...mapState("services", {
      api: state => state.api,
      currentService: state => state.currentService
    })
  },
  data: function() {
    return {
      apiFields: []
    };
  },
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  methods: {
    update(field) {
      this.$emit("update", field);
    },
    delete(field) {
      this.$emit("delete", field);
    }
  }
};
</script>
